import { render, staticRenderFns } from "./InstitutionStats.vue?vue&type=template&id=084c7814&scoped=true&"
import script from "./InstitutionStats.vue?vue&type=script&lang=js&"
export * from "./InstitutionStats.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionStats.vue?vue&type=style&index=0&id=084c7814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c7814",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VAvatar,VCard,VCardTitle,VFlex,VIcon,VLayout,VRating})
